
import { ref, shallowRef, inject, onMounted, nextTick} from 'vue'
import headerMenu from '@/components/header/header.vue'
import Address from '@/components/address/index.vue'
import { Toast, Notify } from 'vant'
import { useRouter, useRoute} from 'vue-router'
import OrderGoods from '@/components/goods/order-goods.vue'
import OrderPrice from '@/components/order/order-price.vue'
import CheckoutVoucher from '@/components/order/checkout-voucher.vue'
import { GetPayFn } from '@/hooks/index'

export default {
  components: {
    headerMenu,
    Address,
    OrderGoods,
    OrderPrice,
    CheckoutVoucher
  },
  props:{},
  setup(props: object){
      nextTick(()=> {
        let $html: any = document.querySelector("html");
        $html.scrollTop = 0;
      });
      const $store: any = inject('$store'),
          currencyUnit:String = $store.getSymbol(),
          currency: String = $store.getSite().currency, 
          route: any = useRoute(),
          mpesa_mobile = ref(),
          router = useRouter();
      
      //清除缓存
      sessionStorage.removeItem('is_checkout');
    
      let $http: any = inject('$http'),
          m_pesa_phone: any = ref(''),
          mpesa_loading: any = ref(false),
          submit_loading: any = ref(false),
          is_loading: any = ref(true),
          m_pesa_error_msg_show: any = ref(false),
          address_item: any = ref(null),
          goods_list: any = shallowRef([]),
          pay_type: any = ref('1'),
          check_cash_redeemed: any = ref(false),
          voucher_list: any = ref([]),
          voucher_show = ref(false),
          voucher_type = ref('Voucher'),
          m_pesa_show = ref(false),
          order_price_obj: any = ref({
            voucher_price: 0,
            goods_discount: 0,
            pay_amount: 0,
            order_mansong_discount: 0,
            coin_redeemed_price: 0,
            tax_total: 0,
            shipping_fee: 0,
            goods_order_amount: 0,
            shipping_discount_amount:0 // 满减包邮的减免金额
          }),
          voucher_code: any = ref(''),
          voucher_sld_id: any = ref(''),
          cash_rewards_info_max: any = ref(''),
          buy_loding: any = ref(true),
          submit_paream: any = ref({}),
          fbq_goods_arr:any = [];
      
      /**
       * 订单金额计算
       */
      const order_price_init_fn = (): void => {
          order_price_obj.value.goods_discount = order_price_obj.value.voucher_price > 0 ? order_price_obj.value.voucher_price : order_price_obj.value.goods_discount;
          order_price_obj.value.pay_amount =  parseInt(order_price_obj.value.goods_order_amount) + 
                                        parseInt(order_price_obj.value.shipping_fee) -
                                        parseInt(order_price_obj.value.order_mansong_discount) -
                                        parseInt(order_price_obj.value.goods_discount) -
                                        parseInt(order_price_obj.value.coin_redeemed_price)-
                                        parseInt(order_price_obj.value.shipping_discount_amount);

      };
      /**
       * 计算优惠券金额
       */
      const voucher_init_fn = () => {
          if(voucher_list.value.length > 0 && voucher_code.value === ''){
              order_price_obj.value.voucher_price = 0
              voucher_sld_id.value = ''
              voucher_list.value.forEach((item: any) => {
                  if(item.is_checked === true){
                      voucher_sld_id.value +=  item.id + "|"
                      if(item.voucher_seller_settlement_type === 1) {
                        order_price_obj.value.voucher_price += Math.floor(Number(item.voucher_price) * parseInt(order_price_obj.value.goods_order_amount) / 100)
                      } else {
                        order_price_obj.value.voucher_price += Number(item.voucher_price)
                      }
                  }
              })
              if(voucher_sld_id.value.indexOf('|') > 0) {
                  voucher_sld_id.value = voucher_sld_id.value.substring(0, voucher_sld_id.value.length - 1)
              }
          }
          order_price_obj.value.goods_discount = 0
          order_price_init_fn()
      };
      /**
       * 获取下单信息
       */
      const get_buy_data_fn = async (address_obj: any) => {
        const checkout_goods_datas = route.params.checkout_goods_datas || sessionStorage.getItem('checkout_goods_datas');
        if(!checkout_goods_datas) {
          router.push('/')
          return false;
        }
        sessionStorage.setItem('checkout_goods_datas', checkout_goods_datas);
        const checkout_goods_obj = JSON.parse(checkout_goods_datas);
        let paream = {
          address_id: address_obj ? address_obj.address_id : '',
          // cart_id: "9034562|6,11954224|1",
          cart_id: checkout_goods_obj.cart_id,
          flash_buy: 0,
          ifcart: checkout_goods_obj.ifcart
        };
         // 添加地址返回到下单页
        if(route.query.address_id) {
          paream.address_id = route.query.address_id;
        }
        submit_paream.value = paream
        let ret = await $http.post_buy_data(paream);
        is_loading.value = false;
        buy_loding.value = false;
        if(ret.code === 200){
              let checkout_datas = ret.data;
              voucher_list.value = checkout_datas.voucher_list;
              voucher_list.value.forEach((item: any) => {
                item.is_checked = true;
              });

              let store_goods_datas: any = [],
                  goods: any = [];
                 fbq_goods_arr = []

              for(let key in checkout_datas.store_cart_list){
                  store_goods_datas.push(checkout_datas.store_cart_list[key]);
              }

              store_goods_datas.forEach((element: any) => {
                  element.goods_list.forEach((item: any) => {
                      goods.push(item);
                      fbq_goods_arr.push({
                            id: item.goods_id,
                            quantity: item.goods_num,
                            item_price: item.goods_price
                        })
                  });
              }); 
              
              address_item.value = checkout_datas.address_info;
              m_pesa_phone.value = checkout_datas.address_info.phone;
              goods_list.value = goods;
              cash_rewards_info_max.value = checkout_datas.cash_rewards_info ? checkout_datas.cash_rewards_info.max : null;
              order_price_obj.value.shipping_fee = checkout_datas.postage_amount + checkout_datas.platform_postage_discount;
              order_price_obj.value.tax_total = checkout_datas.tax_total;
              order_price_obj.value.vat_show_status = checkout_datas.vat_show_status;
              order_price_obj.value.order_mansong_discount = checkout_datas.order_mansong_discount;
              order_price_obj.value.goods_order_amount = checkout_datas.goods_order_amount;
              order_price_obj.value.shipping_discount_amount = checkout_datas.platform_postage_discount;

              //计算优惠券金额
              voucher_init_fn();
          }
          else{
              Notify({ type: 'warning', message: ret.message, duration: 5000, 'className': 'warning_msg_div', 'background': '#FFE6E8', 'color': '#E10106'});
              setTimeout(() => {
                router.go(-1)
              }, 5000);
          }
      }
      
      /**
       * 获取用户地址
       */
      (async() => {
        const res = await $http.post_address({ action: "select" });
        if (res.code === 200) {
          if(res.data.length > 0) {
            let item_obj = res.data[0];
            res.data.forEach((item: any) => {
              if(item.is_default > 0) {
                item_obj = item;
              }
            });
            get_buy_data_fn(item_obj);
          } else {
            get_buy_data_fn(null);
          }
          
        }
      })();

      /**
       * 积分选中或者取消 
       */
      const cash_rewards_check_fn = () => {
          if(check_cash_redeemed.value) {
              order_price_obj.value.coin_redeemed_price = cash_rewards_info_max.value;
          }
          else{
              order_price_obj.value.coin_redeemed_price = 0;
          }
          order_price_init_fn();
      };

      /**
       * 关闭优惠券弹窗
       * type 1 :  voucher， 2 :  voucher code
       */
      const voucher_call_back_fn = (type: number , datas: any) => {
        
          // 清空code
          order_price_obj.value.voucher_price = 0
          voucher_code.value = ''
          if(type === 1){
            voucher_list.value = JSON.parse(JSON.stringify(datas))
          }
          else if(datas.voucher_price && datas.voucher_code_val != ''){
            order_price_obj.value.voucher_price = datas.voucher_price
            voucher_code.value = datas.voucher_code_val
            voucher_sld_id.value = datas.id
          }
          voucher_init_fn()
          voucher_show.value = false
      };
      
      /**
       * 调用接口提交订单
       */
      const post_checkOut_order_fn = async () => {        
          let paream = {
              cart_id: submit_paream.value.cart_id,      //如果是直接购买:商品ID|数量;从购物车购买:购物车ID|数量
              ifcart: submit_paream.value.ifcart,        //1:从购物车,0:直接购买
              flash_buy: submit_paream.value.flash_buy,     //1:秒杀;0:普通
              address_id: submit_paream.value.address_id,   //地址ID
              cash_rewards: order_price_obj.value.coin_redeemed_price,
              voucher: voucher_sld_id.value,      //优惠券"|"隔开
              shipping_voucher: '',
              voucher_code: voucher_code.value,
          }            
          let ret = await $http.post_checkOut_order(paream)
          if(ret.code === 200){
              // 清除缓存
              sessionStorage.removeItem('checkout_goods_datas');
              // facebook埋点\
              // @ts-ignore
              fbq('track', 'InitiateCheckout', {content_type: 'product', currency: currency, contents: JSON.stringify(fbq_goods_arr), value: ret.pay_amount})
              //debugger
              var sn_list = ret.data.order_sn ? ret.data.order_sn : []
              // GA
              // let tmpGA = JSON.parse(common.getStorage('GA_l'))
              // tmpGA.orderCount = ret.data.member_order_count
              // var ad = ''
              // Ad.totalCost = 0
              // Ad.shoogloo_o = null
              // for (var ii = 0; ii < sn_list.length; ii++) {
              //     tmpGA.sn_Array.push(sn_list[ii].order_sn + '|' + sn_list[ii].order_amount + '|' + tmpGA.store_name[sn_list[ii].store_id] + '|' + tmpGA.shippingfeeArray[sn_list[ii].store_id])
              //     // start end utm 统计信息
              //       var sn = sn_list[ii].order_sn
              //     if (Ad.afId) {
              //         if (Ad.utmSource == 'clickwise') {
              //             Ad.totalCost = Number(sn_list[ii].goods_pay_price)
              //             Ad.ActionCode = sn_list[ii].action_code
              //             Ad.Campaignid = sn_list[ii].campaignid
              //             Ad.ApiKey = sn_list[ii].apikey
              //             Ad.orderId = sn + String(sn_list[ii].goods_id)
              //             Ad.AdTypeHtml()
              //             ad = Ad.adHtml
              //         } else {
              //             Ad.totalCost = Number(Ad.totalCost) + Number(sn_list[ii].order_amount)
              //             Ad.orderId = sn.substring(0, sn.length - 2)
              //         }
              //     }
              //     if (Ad.utmSource == 'KMPAP') {
              //         PostAffTracker.setAccountId('default1')
              //         let sale = PostAffTracker.createAction(sn_list[ii].kmpap_code)
              //         sale.setTotalCost(Number(sn_list[ii].goods_pay_price))
              //         sale.setOrderID(sn)
              //         sale.setProductID(Number(sn_list[ii].goods_id))
              //         PostAffTracker.register()
              //     }

              // // end utm 统计信息
              // }
              // // 发送广告联盟统计代码
              // if (Ad.afId && Ad.utmSource != 'clickwise') {
              //     Ad.AdTypeHtml()
              //     ad = Ad.adHtml
              // }
              // var adNode = document.createElement('div')
              // adNode.setAttribute('id', 'adnode')
              // document.body.appendChild(adNode)
              // document.getElementById('adnode').innerHTML = ad
              // Ad.AdRefDump()
              // 广告联盟统计代码end

              // common.setStorage('GA', JSON.stringify(tmpGA))
              // 清除购物车里面的商品
                let cart_goods = $store.getCart();
                let pay_info = paream.cart_id.split(',');
                let arr_cart_info = cart_goods;
                pay_info.forEach((item:any)=>{
                    arr_cart_info = arr_cart_info.filter((item2:any)=>{
                    return item2.cart_id != item.split('|')[0];
                    })
                })
                $store.setCart(arr_cart_info); 
              let pay_sn = ret.data.pay_sn
              let pay_data = {
                  phone:  address_item.value.phone,
                  pay_amount: ret.data.pay_amount,
                  pay_sn: pay_sn,
                  order_sn: ret.data.order_sn[0].order_sn
              }

              if(pay_type.value === '1') {
                  // mpesa支付
                  router.push(`/mpesa?phone=${m_pesa_phone.value}&pay_sn=${pay_sn}`);
                  
              } else {
                  // 收银台支付
                  GetPayFn($http, pay_sn, submit_loading)
              }
              mpesa_loading.value = false;
          }
          else {
            mpesa_loading.value = false;
            submit_loading.value = false;
            Toast.fail(ret.message);
          }
          
      };
      /**
       * m-pesa 支付
       */
      const m_pesa_submit_fn = () => {
        mpesa_loading.value = true;
        let phone_val = m_pesa_phone.value || ''
        phone_val = String(phone_val).replace(/(^254*)/g, '')
        if(phone_val.value === '' || !new RegExp(/^[0]{1}[1-9]{1}[0-9]{8}$|^[1-9]{1}[0-9]{8}$/).test(phone_val)){
            m_pesa_error_msg_show.value = true;
            mpesa_loading.value = false;
            return;
        }
        m_pesa_show.value = false
        m_pesa_error_msg_show.value = false;
        post_checkOut_order_fn();
      };

      /**
       * 提交订单
       */
      const submit_btn_fn = () => {
          submit_loading.value = true;
          if(!address_item.value ||  !address_item.value.address_id) {
              Toast.fail('Please select an address');
              return false
          }
          if(pay_type.value == '1'){
              m_pesa_show.value = true
              submit_loading.value = false;
          }else{
              //收银台支付
              post_checkOut_order_fn();
          }
      };
      /**
       * 跳转到地址
      */
     const fn_go_back = (val:string)=>{
       $store.setGoBack('checkout')
       router.push({
         path:"/address-list",
         query:{
           is_checkout:val
         },
         
       })
     }
      return {
        voucher_call_back_fn,
        m_pesa_error_msg_show,
        m_pesa_submit_fn,
        m_pesa_phone,
        m_pesa_show,
        voucher_type,
        address_item,
        goods_list,
        pay_type,
        check_cash_redeemed,
        order_price_obj,
        cash_rewards_info_max,
        cash_rewards_check_fn,
        currencyUnit,
        router,
        voucher_show,
        voucher_list,
        voucher_code,
        submit_btn_fn,
        mpesa_mobile,
        is_loading,
        mpesa_loading,
        submit_loading,
        fn_go_back
      }
  }
}
